<header>
  <h1 class="truncate" [matTooltip]="data.title" matTooltipShowDelay="500" mat-dialog-title>
    <mat-icon fontIcon="{{ data.titleIcon }}"></mat-icon>
    {{ data.title }}
  </h1>
</header>
<div mat-dialog-content class="grid-2">
  @if (Array.isArray(data.message)) {
    @for (issue of data.message; track issue) {
      <p class="issue">
        {{ issue }}
      </p>
    }
  } @else {
    <h2>{{ data.message }}</h2>
  }
</div>
<section mat-dialog-actions class="footer-btns" [ngClass]="data.alternativeText ? 'three-buttons' : ''">
  <button mat-button theme-style="nav" appRipple [mat-dialog-close]="false" tabindex="0">{{ data.negativeText }}</button>
  <button mat-button theme-style="nav" appRipple [mat-dialog-close]="true">{{ data.positiveText }}</button>
  @if (data.alternativeText) {
    <button mat-button theme-style="nav" appRipple [mat-dialog-close]="data.alternativeText">{{ data.alternativeText }}</button>
  }
</section>
